import * as API from '@/services/API';

export default {
  getStaffStatuses() {
    return API.apiClient.get('/staff-status');
  }
};
